// extracted by mini-css-extract-plugin
module.exports = {"heading":"MapListPage_heading__Xj1_J","mapList":"MapListPage_mapList__1MDkD","mapLink":"MapListPage_mapLink__c6tMG","mapName":"MapListPage_mapName__1NSK-"};